import {
	Edit,
	SimpleForm,
	TextInput,
	useRedirect,
	Toolbar,
	SaveButton,
	BooleanInput,
	SelectInput,
	DeleteButton,
} from 'react-admin';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CustomToolbar = () => {
	const redirect = useRedirect();
	return (
		<Toolbar>
			<SaveButton />
			<DeleteButton mutationMode="pessimistic" />
			<Button
				onClick={() => redirect('/monitoring-statements')}
				startIcon={<ArrowBackIcon />}
				sx={{ ml: 2 }}
				color="secondary"
			>
				Abbrechen
			</Button>
		</Toolbar>
	);
};

export const MonitoringEdit = () => (
	<Edit>
		<SimpleForm toolbar={<CustomToolbar />}>
			<TextInput source="description" fullWidth />
			<SelectInput
				source="database"
				choices={[
					{ id: 'SSIS', name: 'SSIS' },
					{ id: 'PROSOOM', name: 'Prosoom Live' },
					{ id: 'ANALYTICS', name: 'Analytics' },
					{ id: 'CLICKHOUSE', name: 'ClickHouse' },
				]}
			/>
			<TextInput source="statement" multiline fullWidth />
			<TextInput source="messageStatement" multiline fullWidth />
			<TextInput
				source="threshold"
				helperText={
					'Das Statement wird erst ausgeführt, wenn die Bedingung nicht erfüllt ist.'
				}/>
			<TextInput
				source="executionTime"
				helperText={
					'Zu welcher Uhrzeit soll geprüft werden?'
				}/>
			<SelectInput
				source="priority"
				choices={[
					{ id: '1', name: 'info' },
					{ id: '2', name: 'debug' },
					{ id: '3', name: 'warning' },
					{ id: '4', name: 'fatal error' },
				]}
				helperText={
					'Welche Art Monitoring ist das?'
				}
			/>
			<BooleanInput source="status" />
		</SimpleForm>
	</Edit>
);